import React, { lazy } from "react";
import { BsIncognito } from "react-icons/bs";
import { RiUserStarLine } from "react-icons/ri";

const PageDashboard = lazy(() => import("../components/page.dashboard"));
const AccountOrders = lazy(() => import("../components/page.account.orders"));
const AccountPayment = lazy(() => import("../components/page.account.payment"));
const AccountData = lazy(() => import("../components/page.account.data"));
const AccountSecurity = lazy(
  () => import("../components/page.account.security"),
);
const AccountMembers = lazy(() => import("../components/page.account.members"));
const ReportList = lazy(() => import("../components/page.report.list"));
const Alerts = lazy(() => import("../components/page.alerts"));
const SupportList = lazy(() => import("../components/page.support.list"));
const RequestRemoval = lazy(() => import("../components/page.removal"));
const Reset = lazy(() => import("../components/reset"));
const ReputationOverview = lazy(
  () => import("../components/page.reputation.overview"),
);
const ReputationContent = lazy(
  () => import("../components/page.reputation.content"),
);
const SearchResults = lazy(() => import("../components/page.searchResults"));
const PrivateBrowser = lazy(() => import("../components/page.private.browser"));
const PrivacyGift = lazy(() => import("../components/page.privacyGift"));

const ThemeRoutes = [
  {
    path: "/dashboard",
    name: "dashboard",
    icon: "mdi mdi-home",
    component: PageDashboard,
    title: "Dashboard | Delete My Info",
    description:
      "Access your personalized dashboard at Delete My Info. Manage your account, view activities, and customize your preferences in one place.",
  },
  {
    collapse: true,
    path: "/privacy",
    name: "privacy",
    icon: "mdi mdi-security",
    state: "privacypages",
    child: [
      {
        path: "/privacy/report",
        name: "reports",
        mini: "B",
        icon: "mdi mdi-chart-areaspline",
        component: ReportList,
        title: "Privacy Report | Delete My Info",
        description:
          "View your privacy report at Acme Inc. Understand how your personal information is managed and ensure your privacy preferences are upheld.",
      },
      {
        path: "/privacy/alert",
        name: "alerts",
        mini: "B",
        icon: "mdi mdi-alert",
        component: Alerts,
        title: "Privacy Alerts | Delete My Info",
        description:
          "Stay informed about privacy alerts at Delete My Info. Mainly manages Actions and Alerts of customer.",
      },
    ],
  },
  {
    path: "/datasheet",
    name: "myDataSheet",
    icon: "mdi mdi-book-open",
    component: AccountMembers,
    state: "datasheetpages",
    title: "Customer Datasheets | Delete My Info",
    description:
      "Explore detailed datasheets for our cusotmers, including deep details.",
  },
  {
    collapse: true,
    path: "/reputation",
    name: "reputation",
    reactIcon: <RiUserStarLine className="cursor-pointer" />,
    hideForNoneReputationUsers: true,
    state: "reputationpages",
    child: [
      {
        path: "/reputation/overview",
        name: "overview",
        mini: "B",
        icon: "mdi mdi-content-paste",
        component: ReputationOverview,
        title: "Reputation Overview | Delete My Info",
        description:
          "Learn about our reputation and trustworthiness. Discover what sets us apart and why customers choose us.",
      },
      {
        path: "/reputation/contents",
        name: "contents",
        mini: "B",
        icon: "mdi mdi-folder-image",
        component: ReputationContent,
        title: "Reputation Contents | Delete My Info",
        description:
          "Learn about our reputation and trustworthiness. Discover what sets us apart and why customers choose us.",
      },
    ],
  },
  {
    path: "/priacyGift",
    name: "privacyGift",
    icon: "fas fa-gift",
    component: PrivacyGift,
    title: "Privacy Gift | Delete My Info",
    description: "Browse our selection of privacy-focused gifts.",
  },
  {
    path: "/searchresults",
    name: "searchEngine",
    icon: "mdi mdi-account-search",
    component: SearchResults,
    title: "Search Results | Delete My Info",
    description: "ind relevant information about [keywords] on our website. ",
  },
  {
    path: "/privatebrowser",
    name: "googleSearchResults",
    target: "_blank",
    reactIcon: <BsIncognito className="cursor-pointer" />,
    component: PrivateBrowser,
    title: "Private Browser | Secure Browsing Experience",
    description:
      "Discover our private browser for secure and anonymous browsing. Protect your online privacy with our advanced features.",
  },
  {
    path: "/support",
    name: "supports",
    icon: "mdi mdi-headset",
    component: SupportList,
    title: "Customer Support | Contact Us | Delete My Info",
    description:
      "Get help with products, services, and more. Contact our support team for assistance with any inquiries or issues.",
  },
  {
    collapse: true,
    path: "/account",
    name: "accountSettings",
    state: "accountpages",
    icon: "mdi mdi-account-circle",
    child: [
      {
        path: "/account/security",
        name: "loginSecurity",
        mini: "B",
        icon: "mdi mdi-security",
        component: AccountSecurity,
        title: "Account Security | Protect Your Account | Delete My Info",
        description:
          "Learn about account security measures and best practices. Keep your account safe with our tips and guidelines.",
      },
      {
        path: "/account/orders",
        name: "orderInvoices",
        mini: "B",
        icon: "mdi mdi-file-document",
        component: AccountOrders,
        title: "Account Orders | Order History | Delete My Info",
        description: "Manage and track your purchases with ease.",
      },
      {
        path: "/account/payment",
        name: "paymentOptions",
        mini: "B",
        icon: "mdi mdi-credit-card",
        component: AccountPayment,
        title: "Account Payment | Payment Methods | Delete My Info",
        description:
          "Manage your payment methods and transactions. Securely update, add, or remove payment options.",
      },
    ],
  },
  {
    path: "/datasheets/data",
    component: AccountData,
    hide: true,
    title: "Customer Datasheets | Delete My Info",
    description:
      "Explore detailed datasheets for our cusotmers, including deep details.",
  },
  {
    path: "/supports/reset",
    component: Reset,
    hide: true,
    title: "Password Reset | Account Recovery | Delete My Info",
    description: "Reset your password securely.",
  },
  {
    path: "/supports/request/add",
    component: RequestRemoval,
    hide: true,
    title: "Add Support Request | Delete My Info",
    description:
      "Submit a new support request. Contact our support team for help with any inquiries or assistance you need.",
  },
  {
    path: "/",
    pathTo: "/dashboard",
    name: "dashboard",
    redirect: true,
    title: "Dashboard | Delete My Info",
    description:
      "Access your personalized dashboard at Delete My Info. Manage your account, view activities, and customize your preferences in one place.",
  },
  {
    path: "/privacy/report",
    hide: true,
    component: ReportList,
    title: "Privacy Report | Delete My Info",
    description:
      "View your privacy report at Acme Inc. Understand how your personal information is managed and ensure your privacy preferences are upheld.",
  },
  {
    path: "/privacy/alert",
    hide: true,
    component: Alerts,
    title: "Privacy Alerts | Delete My Info",
    description:
      "Stay informed about privacy alerts at Delete My Info. Mainly manages Actions and Alerts of customer.",
  },
  {
    path: "/account/security",
    hide: true,
    component: AccountSecurity,
    title: "Account Security | Protect Your Account | Delete My Info",
    description:
      "Learn about account security measures and best practices. Keep your account safe with our tips and guidelines.",
  },
  {
    path: "/account/orders",
    hide: true,
    component: AccountOrders,
    title: "Account Orders | Order History | Delete My Info",
    description: "Manage and track your purchases with ease.",
  },
  {
    path: "/account/payment",
    hide: true,
    component: AccountPayment,
    title: "Account Payment | Payment Methods | Delete My Info",
    description:
      "Manage your payment methods and transactions. Securely update, add, or remove payment options.",
  },
  {
    path: "/reputation/overview",
    hide: true,
    component: ReputationOverview,
    title: "Reputation Overview | Delete My Info",
    description:
      "Learn about our reputation and trustworthiness. Discover what sets us apart and why customers choose us.",
  },
  {
    path: "/reputation/contents",
    hide: true,
    component: ReputationContent,
    title: "Reputation Contents | Delete My Info",
    description:
      "Learn about our reputation and trustworthiness. Discover what sets us apart and why customers choose us.",
  },
];
export default ThemeRoutes;
